define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Relationship",
	"csi/form/Widget",
	"csi/store/_base",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,Relationship,FormWidget,csi_store,Names,xml,Query) {

	return declare(FormWidget, {
		_productStructureStore: null,

		getFieldStore: function(/*csi.def.Field*/field, /*String*/value) {
			// summary: get store for product-structure drop-down
			var	productStructure = this.getViewNode();
			return this._productStructureStore = this._productStructureStore || this._getStore(lang.mixin(new Relationship(), {
				m_typeNode: "ProductStructure",
				m_query: new Query()
					.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, productStructure.$URL)
					.Attr("State", xml.OP_EQUALS, "ProductStructureState:Active")
			}));
		},

		_getStore: function(/*Relationship*/r) {
			// summary: get store given relationship
			var	storeOptions = {data: [csi_store.nameObject("")]};
			csi_store.namesOptionsByRelationship(this.getContext(), r, storeOptions);
			return new Names(storeOptions);
		}
	});
});